import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppointmentsTurnsService } from 'src/app/services/turns-services/appointments-turns-service/appointment-turns.service';
import { AppointmentTaken } from 'src/app/models/turns-models/appointment-taken.model';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-turns-appointment-confirmation-dialog',
  templateUrl: './turns-appointment-confirmation-dialog.component.html',
  styleUrls: ['./turns-appointment-confirmation-dialog.component.scss']
})
export class TurnsAppointmentConfirmationDialogComponent implements OnInit {

  ticketHtml: string;
  minDate: number;
  maxDate: number;
  confirmed: boolean;
  validateAppointmentSubscription: Subscription;
  deleteAppointmentSubscription: Subscription;

  constructor(private appointmentsTurnsService: AppointmentsTurnsService,
              public dialogRef: MatDialogRef<TurnsAppointmentConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public appointment) { }

  ngOnInit() {
    this.setMinDate();
    this.setMaxDate();
  }

  public getTurn(internalId) {
     this.validateAppointmentSubscription = this.appointmentsTurnsService.validateAppointment(internalId).subscribe(
      (res: AppointmentTaken) => {
        this.confirmed = true;
        this.ticketHtml = res.TurnTicketHtml;
        this.dialogRef.close(this.appointment);
      }
    );
  }

  public deleteAppointment(internalId) {
     this.deleteAppointmentSubscription = this.appointmentsTurnsService.deleteAppointment(internalId).subscribe(
      (res) => {
        this.appointmentsTurnsService.refreshAppointmentsSearch();
        this.dialogRef.close();
      }
    );
  }

  public turnCanBeGot(appointment) {
    if ((moment().valueOf() >= (appointment.AppointmentDate - appointment.AllowBeforeMilliseconds)) && (moment().valueOf() <= (appointment.AppointmentDate + appointment.AllowAfterMilliseconds))) {
      return true;
    }
    return false;
  }

  private setMinDate() {
    this.minDate = (this.appointment.AppointmentDate - this.appointment.AllowBeforeMilliseconds);
  }

  private setMaxDate() {
    this.maxDate = (this.appointment.AppointmentDate + this.appointment.AllowAfterMilliseconds);
  }

  public print() {
    const w = window.open();
    w.document.write(this.ticketHtml);
    w.print();
    w.close();
  }
}
